<app-header></app-header>

<main class="min-h-screen bg-rainbow-gradient flex flex-col pt-16">
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>
<app-cookie-banner></app-cookie-banner>

